var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"PublicSwitches",staticClass:"PublicSwitches"},[_c('b-form-checkbox',{attrs:{"switch":"","size":"lg"},on:{"change":_vm.UpdateCheck},model:{value:(_vm.temp_value),callback:function ($$v) {_vm.temp_value=$$v},expression:"temp_value"}},[_vm._v(_vm._s(_vm.GetName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }